import React, { FC, ReactElement, useEffect, useState } from 'react';

import { AuthTokenModel } from '@core/models/auth.model';
import { IRouterProps } from '@core/models/generic.model';
import { useAppSelector } from '@redux/hooks';
import { RootState } from '@redux/store';
import ForgetPassword from 'components/auth/ForgetPassword';
import LoginForm from 'components/auth/LoginForm';
import EnterLoginOtp from 'components/auth/EnterLoginOtp';


type IProps = {
    router: IRouterProps;
};

const Login: FC<IProps> = ({ router }): ReactElement => {
    // -------------------------------------------------------------------------------------
    document.title = `Login | ANTAR Admin Dashboard`;
    // -------------------------------------------------------------------------------------
    const [userToken, setUserToken] = useState<AuthTokenModel>({} as AuthTokenModel);
    // -------------------------------------------------------------------------------------
    const showOtpModal = useAppSelector((state: RootState) => state.authState.showOtpModal);
    const showForgetPasswordModal = useAppSelector((state: RootState) => state.authState.showForgetPasswordModal);
    // -------------------------------------------------------------------------------------
    return (
        <>
                <LoginForm setUserToken={setUserToken} />
        </>
    );
};

export default Login;
